import React, { useCallback, useRef } from 'react';
import { debounce } from '../../helpers/debounce';
import { StyledTagListContainer, TagListInner } from './styles';
export const TagListV2 = ({ name, value, children, onChange, align = 'left', spacingLeft = '0', 'data-testid': dataTestId, }) => {
    const [fitsInViewport, setfitsInViewport] = React.useState(true);
    const innerRef = useRef(null);
    const onInputChange = useCallback(e => (onChange ? onChange(e.target.value, e) : true), [onChange]);
    React.useEffect(() => {
        const tagListElement = innerRef.current;
        const isOutOfViewportWidth = (elem) => {
            // Get element's bounding
            const bounding = elem.getBoundingClientRect();
            // Check if it's out of the viewport on each side
            const rightFitsInViewport = bounding.right >=
                // eslint-disable-next-line react-hooks-ssr/react-hooks-global-ssr
                document.documentElement.clientWidth;
            // eslint-disable-next-line react-hooks-ssr/react-hooks-global-ssr
            return !rightFitsInViewport;
        };
        let isMounted = true;
        // Resizing the horizontal sliders will cause an expensive
        // forced layout reflow. Debouncing resizing improves that
        // a bit.
        const update = debounce(() => {
            if (!isMounted || !tagListElement) {
                return;
            }
            setfitsInViewport(isOutOfViewportWidth(tagListElement));
        }, 100);
        update();
        window.addEventListener('resize', update);
        return () => {
            isMounted = false;
            window.removeEventListener('resize', update);
        };
    }, []);
    if (children.length === 0)
        return null;
    return (React.createElement(StyledTagListContainer, { fitsInViewport: fitsInViewport, align: align, "data-testid": dataTestId },
        React.createElement(TagListInner, { ref: innerRef, spacingLeft: spacingLeft, fitsInViewport: fitsInViewport, align: align }, React.Children.map(children, child => {
            if ('value' in child.props) {
                return React.cloneElement(child, {
                    isChecked: child.props.value === value,
                    name,
                    onChange: onInputChange,
                });
            }
            else {
                return child;
            }
        }))));
};
